import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, UiUtils, NumberFormatter, DateFormatter, i18n, isAuth } from 'arm-common';
import { isNullOrUndefined } from 'util';
import SwitchButton from '../shared/switchButtonV4.jsx'
import ProdottoActions from './prodotto_actions'
import LineaDocumentUpload from './LineaDocumentUpload.jsx'
import Upload from './upload.jsx'
import { resolve } from 'path';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import FondiAction from './../fondi/fondi_action.js'

class LineaCard extends React.Component {

    constructor(props) {
        super(props);
        this.componentName = '[LineaCard.jsx] ';
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.onClickSalvaLinea = this.onClickSalvaLinea.bind(this);
        this.inputChangeHandlerFondi = this.inputChangeHandlerFondi.bind(this);
        this.addOptionButton = this.addOptionButton.bind(this);
        this.showConfirmPanelFondo = this.showConfirmPanelFondo.bind(this);
        this.annullaCreazioneFondo = this.annullaCreazioneFondo.bind(this);
        this.validateFormFondo = this.validateFormFondo.bind(this);
        this.salvaSottostante = this.salvaSottostante.bind(this);
        this.columnDelete = this.columnDelete.bind(this);
        this.uploadDoc = this.uploadDoc.bind(this);
        this.cancelUploadDoc = this.cancelUploadDoc.bind(this);
        this.inizializzaNuovoFondo = this.inizializzaNuovoFondo.bind(this);
        this.showUploadLinea = this.showUploadLinea.bind(this);
        this.downloadOnClick = this.downloadOnClick.bind(this);
        this.columnDeleteDoc = this.columnDeleteDoc.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.inzializzaEliminaDocument = this.inzializzaEliminaDocument.bind(this);
        this.deleteProdottoLineaFondoDocument = this.deleteProdottoLineaFondoDocument.bind(this);
        this.inzializzaEliminaDocumentLinea = this.inzializzaEliminaDocumentLinea.bind(this);
        this.deleteLineaDocument = this.deleteLineaDocument.bind(this);
        this.showConfirmDeleteLinea = this.showConfirmDeleteLinea.bind(this);
        this.showConfirmPanelFondoModifica = this.showConfirmPanelFondoModifica.bind(this);
        this.salvaSottostanteFondoModifica = this.salvaSottostanteFondoModifica.bind(this);
        this.valueCodIsin = this.valueCodIsin.bind(this);
        this.state = {
            disabilitaSwitch: false,
            validationSottoStanti: new Map(),
            showConfirm: false,
            modificaFondo: false,
            showUpload: false,
            showUploadLinea: false,
            idProdottoLineaFondo: null,
            showDel: false,
            showConfirmDelete: false,
            showConfirmDeleteLinea: false,
            docDaEliminare: null,
        }
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        // let columns = [
        //     { field: 'idProdottoLineaFondo', title: 'Id', sortable: 'true' },
        //     { field: 'fonDescrizione', title: i18n('ARM_CORE_PRODUCT.MANAGE.DESCRIZIONE', 'Descrizione') },
        //     { field: 'percMin', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MIN', '% Min') },
        //     { field: 'percMax', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MAX', '% Max') },
        //     { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Update'), formatter: this.dataFormat },
        //     // { field: 'edit', title: 'Modifica', formatter: this.columnEdit, },
        //     { field: 'elimina', title: 'Elimina', formatter: this.columnDelete, }

        // ];


        // $(this.refs.fondiTable).bootstrapTable({
        //     columns: columns,
        //     idField: "fonId",
        //     sortable: true,
        //     search: true,
        //     pageSize: 5,
        //     showColumns: true,
        //     showExport: true,
        //     exportDataType: 'all',
        //     exportTypes: ['csv', 'excel'],
        //     onClickRow: (row, $element, field) => this.editOnClick(row, $element, field),
        //     sortOrder: "desc",
        //     pagination: true,


        // });

        // $(this.refs.fondiTable).bootstrapTable('load', this.props.linea.listProdottoLineaFondi);

        let accordion = document.getElementsByClassName("prodottoLinea" + this.props.index)[0];

        accordion.addEventListener("click", () => setTimeout(() => this.accordionOnClick(), 300));

        // document.getElementById("").addEventListener("loadeddata")
        // addEventListener()


    }

    accordionOnClick() {
        let columns = [
            { field: 'idProdottoLineaFondo', title: 'Id', sortable: 'true' },
            { field: 'fonDescrizione', title: i18n('ARM_CORE_PRODUCT.MANAGE.DESCRIZIONE', 'Descrizione') },
            { field: 'percMin', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MIN', '% Min') },
            { field: 'percMax', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MAX', '% Max') },
            { field: 'fonIsin', title: i18n('ARM_CORE_PRODUCT.MANAGE.CODICE_ISIN', 'Codice Isin'), formatter: this.valueCodIsin },
            { field: 'dataInizio', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_INIZIO', 'Data Inizio'), formatter: this.dataFormat },
            { field: 'dataFine', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_FINE', 'Data Fine'), formatter: this.dataFormat },
            { field: 'dataInizioBanca', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_INIZIO_BANCA', 'Data Inizio Banca'), formatter: this.dataFormat },
            { field: 'dataFineBanca', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_FINE_BANCA', 'Data Fine Banca'), formatter: this.dataFormat },
            // { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Update'), formatter: this.dataFormat },
            { field: 'edit', title: 'Modifica', formatter: this.columnEdit, },
            { field: 'elimina', title: 'Elimina', formatter: this.columnDelete, },
            { field: 'docId', title: 'KID', formatter: this.uploadDoc, },
            { field: 'docIdDel', title: 'Elimina KID', formatter: this.columnDeleteDoc, }

        ];


        let tableAcc = document.getElementById("tableAcc" + this.props.index);

        $(tableAcc).bootstrapTable({
            columns: columns,
            idField: "fonId",
            sortable: true,
            search: true,
            pageSize: 5,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.editOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        $(tableAcc).bootstrapTable('load', this.props.linea.listProdottoLineaFondi);
    }

    componentWillUnmount() {
        // document.removeEventListener("")
    }

    valueCodIsin(value, row, index) {
        let fondoTrovato = this.props.fondiList.find(fon => fon.fonId === row.idFondo);
        let temp = fondoTrovato ? fondoTrovato.fonIsin : '-';
        return temp;
    }

    componentDidUpdate() {
        if (this.props.linea.listProdottoLineaFondi) {
            // $(this.refs.fondiTable).bootstrapTable('load', this.props.linea.listProdottoLineaFondi);
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.linea && nextProps.linea.listProdottoLineaFondi && nextProps.linea.listProdottoLineaFondi) {
            if (nextProps.linea.listProdottoLineaFondi !== this.props.linea.listProdottoLineaFondi) {
                $(this.refs.fondiTable).bootstrapTable('load', nextProps.linea.listProdottoLineaFondi);
            }
        }
    }

    columnEdit(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-edit fa-fw'></i></button>";
        return temp;
    }

    addOptionButton(index) {
        this.showConfirmPanelFondo();
        this.props.addOptionButton(index);
    }

    inizializzaNuovoFondo() {
        this.setState({
            validationSottoStanti: new Map(),
            modificaFondo: false
        })
        this.props.inizializzaNuovoFondo().then(
            resolve => {
                this.showConfirmPanelFondo();
            }
        )

    }



    onClickSalvaLinea(e) {
        // if (this.validateForm()) {
        this.props.onClickSalvaLinea(e);
        resolve => {
            this.accordionOnClick();
        }
    }

    validateFormFondo() {

        let required = ['percMin', 'percMax', 'idFondo'];
        if (this.state.modificaFondo) {
            required = ['percMin', 'percMax'];
        }
        let validation = new Map();


        for (let i = 0; i < required.length; i++) {

            if (this.props.fondo[required[i]] === null || this.props.fondo[required[i]] === undefined || this.props.fondo[required[i]] === "") {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }

            if (required[i] === "idFondo") {
                let indexTrovato = this.props.linea.listProdottoLineaFondi.findIndex(fon => fon.idFondo === this.props.fondo.idFondo);

                if (indexTrovato !== -1) {
                    validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_ESISTENTE_LISTA', 'Sottostante gia aggiunto sulla lista'));
                }
            }
        }

        let fondo = this.props.fondo;
        if (fondo.percMin && fondo.percMin !== "") {
            if (fondo.percMin > 100) {
                validation.set("percMin", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }

        if (fondo.percMin && fondo.percMax &&
            Number(fondo.percMax) < Number(fondo.percMin)) {
            validation.set("percMax", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', '% massima minore della % mininima'));
        }

        if (fondo.percMax && fondo.percMax !== "") {
            if (fondo.percMax > 100) {
                validation.set("percMax", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }

        if (fondo.dataInizio && fondo.dataFine && Number(fondo.dataFine) < Number(fondo.dataInizio)) {
            validation.set("dataFine", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', '% massima minore della % mininima'));
        }
        if (fondo.dataInizioBanca && fondo.dataFineBanca && Number(fondo.dataFineBanca) < Number(fondo.dataInizioBanca)) {
            validation.set("dataFineBanca", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', '% massima minore della % mininima'));
        }


        this.setState({ validationSottoStanti: validation })
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    validateForm() {
        let listProdottoLineaFondi = this.props.linea.listProdottoLineaFondi;
        let required = ['percMin', 'percMax', 'idFondo'];
        let validation = new Map();
        if (listProdottoLineaFondi && this.props.sceltaLibera) {

            listProdottoLineaFondi.forEach((element, index) => {
                for (let i = 0; i < required.length; i++) {

                    if (element[required[i]] === null || element[required[i]] === undefined || element[required[i]] === "") {
                        validation.set(required[i] + index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
            });

            this.setState({ validationSottoStanti: validation })
            if (validation.size === 0) {
                return true;
            }
            return false;
        }
    }




    inputChangeHandler(event, id) {
        console.log(this.componentName + "inputChangeHandler");
        if ((isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) && isNullOrUndefined(id)) {
            return
        }
        let parametro;
        let value;
        if (id !== undefined && id !== null) {
            parametro = id;
            value = event
        } else {
            parametro = event.currentTarget.name;
            value = event.target.value;
        }
        let type = event.target.type;
        if (type === "date" && value !== undefined) {
            let data = new Date(value);
            value = data.getTime();
        }

        if (type === "number" && value === "") {
            value = null;
        } else if (type === "number" && value && value !== "") {
            value = Number(value)
        }

        if (parametro === "linDettaglioSottostanti" || type === 'checkbox') {
            if (value === "true") {
                value = true;
            } else if (value === "false") {
                value = false;
            }
        }

        this.props.handleChangeEditLinea(this.props.index, parametro, value).then(
            resolve => {

                this.props.validateForm(this.props.index);
                // if (parametro === "linMinSottostanti") {
                //     this.props.manageLineaSottostanti(value, this.props.index);
                // }
                // else if (parametro === "gestioneSeparata") {
                //     this.props.handleChangeEditLinea(this.props.index, "sceltaLibera", false);
                // }
            }
        )
    }


    showConfirmPanelFondoModifica() {
        this.setState({ modificaFondo: !this.state.modificaFondo })
    }

    inputChangeHandlerFondi(parametro, value) {

        let linea = this.props.linea;
        let fondo = linea.listProdottoLineaFondi;
        let idCompagnia = null;
        if(this.props.prodotto !== undefined && this.props.prodotto.prodottoCmpPojo !== undefined  && this.props.prodotto.prodottoCmpPojo.compagnia !== undefined){
            idCompagnia = this.props.prodotto.prodottoCmpPojo.compagnia.id;
        }

        // if (parametro === "dataInizio" || parametro === "dataFine" || parametro === "dataInizioBanca" || parametro === "dataFineBanca") {
        //     let date = new Date(value);
        //     value = date.getTime();

        // }


        
        // this.props.inputChangeHandlerFondi(this.props.index, fondi.length - 1, parametro, value).then(
        this.props.inputChangeHandlerFondo(parametro, value).then(
            resolve => {
                if (parametro === "idFondo") {
                    if (this.props.fondiList) {
                        let fondoTrovato = this.props.fondiList.find(fon => fon.fonId === this.props.fondo.idFondo);

                        if (fondoTrovato) {
                            this.props.getFondoDetails(fondoTrovato.fonId).then(
                                resolve => {
                                    if(resolve !== undefined && resolve !== null && resolve.listStumentiCompagnia !== null && resolve.listStumentiCompagnia !== undefined){
                                        resolve.listStumentiCompagnia.forEach((element, index) => {
                                               if(element !== null && element !== undefined && element.codStrum === fondoTrovato.fonId && element.idCompagnia === idCompagnia){
                                               let compagnia = element;
                                               fondoTrovato.dataInizio = compagnia.dataInizio;
                                               fondoTrovato.dataFine = compagnia.dataFine;
                                               fondoTrovato.dataInizioBanca = compagnia.dataInizioBanca;
                                               fondoTrovato.dataFineBanca = compagnia.dataFineBanca;
                                               this.props.inputChangeHandlerFondo("dataInizio", fondoTrovato.dataInizio)
                                               this.props.inputChangeHandlerFondo("dataFine", fondoTrovato.dataFine)
                                               this.props.inputChangeHandlerFondo("dataInizioBanca", fondoTrovato.dataInizioBanca)
                                               this.props.inputChangeHandlerFondo("dataFineBanca", fondoTrovato.dataFineBanca)

                                               }
                                            
                                        });
                                    }
                                },
                                reject => {
                                    console.log(this.componentName + ' KO');
                                }
                            )

                            this.props.inputChangeHandlerFondo("fonDescrizione", fondoTrovato.fonDescrizione).then(
                                resolve => {
                                    this.props.inputChangeHandlerFondo("codIsin", fondoTrovato.fonIsin)
                                }
                            )
                        }
                    }
                }
                this.validateFormFondo();
            }
        )

    }

    editOnClick(row, $element, field) {
        console.log(this.componentName + " deleteOnClick()");

        if (field === "elimina" && !this.props.disabled) {
            // let index = this.props.linea.listProdottoLineaFondi.findIndex(row);
            this.props.removeOptionFromList(this.props.index, $element.index())
        } else if (field === "edit" && !this.props.disabled) {
            this.props.inizializzaModificaFondo(row).then(
                resolve => {
                    this.setState({
                        validationSottoStanti: new Map(),
                        modificaFondo: true
                    })
                    //this.showConfirmPanelFondo();
                }
            )
        } else if (field === "docId") {
            if (row.docId) {
                this.downloadOnClick(row.docId)
            } else if (row.idProdottoLineaFondo && !this.props.disabled) {
                this.setState({ idProdottoLineaFondo: row.idProdottoLineaFondo })
                this.setState({ showUpload: !this.state.showUpload })
            }
        } else if (field === "docIdDel" && !this.props.disabled) {
            if (row.idProdottoLineaFondo && row.docId)
                this.inzializzaEliminaDocument(row.idProdottoLineaFondo);

        }
    }

    inzializzaEliminaDocument(idDoc) {

        this.setState({ docDaEliminare: idDoc, showConfirmDelete: true });

    }

    deleteProdottoLineaFondoDocument() {
        this.showConfirmDelete();
        this.props.deleteProdottoLineaFondoDocument(this.state.docDaEliminare).then(
            resolve => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
                this.props.getLineProdotto(this.props.linea.idProdotto);
            }
        )
    }

    cancelUploadDoc() {
        this.setState({ showUpload: !this.state.showUpload })
    }

    showUploadLinea() {
        if (this.props.linea.idProdottoLinea) {
            this.setState({ showUploadLinea: !this.state.showUploadLinea })
        }
    }

    inzializzaEliminaStrumCmp(codStrumComp) {

        this.setState({ strumCmpDaEliminare: codStrumComp, showConfirmDelete: true });

    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    showConfirmDeleteLinea() {
        this.setState({ showConfirmDeleteLinea: !this.state.showConfirmDeleteLinea });
    }

    deleteStrumentoCmp() {

        this.showConfirmDelete();

        this.props.deleteStrumentoCmp(this.state.strumCmpDaEliminare).then(

            resolve => {
                this.props.listaStrumentoCompagnie(this.props.fondoDetails.fonId).then(
                    resolve => {
                        // $(this.refs.compagniaTable).bootstrapTable('load', resolve);
                    }
                )
            }
        )
    }


    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        if (this.props.disabled) {
            temp = "<button class='btn btn-danger btn-sm' disabled><i class='fas fa-trash-alt'  data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
            return temp;
        }
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    columnDeleteDoc(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        if (row.docId) {
            if (this.props.disabled) {
                temp = "<button class='btn btn-danger btn-sm' disabled><i class='fas fa-trash-alt'  data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
            } else {
                temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' disabled data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
            }
            return temp;
        }
        //temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    uploadDoc(value, row, index) {
        let temp;
        if (row.idProdottoLineaFondo && !row.docId) {
            if (this.props.disabled) {
                temp = "<button class='btn btn-primary btn-sm' disabled><i class='fas fa-upload'></i></button>";
            } else {
                temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-upload'></i></button>";
            }
            return temp;
        } else if (row.docId) {

            temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-download' data-toggle='tooltip' data-placement='top' title='Download'/></button>";
        }
        return temp;
    }

    salvaSottostante() {
        if (this.validateFormFondo()) {
            this.showConfirmPanelFondo();
            this.props.salvaSottostante(this.props.index).then(
                resolve => {
                    // this.props.listaStrumentoCompagnie(this.props.fondoDetails.fonId).then(
                    //     resolve => {
                    // $(this.refs.compagniaTable).bootstrapTable('load', resolve);
                    //     }
                    // )
                }
            )
        }
    }

    salvaSottostanteFondoModifica() {
        if (this.validateFormFondo()) {
            this.showConfirmPanelFondoModifica();
            this.props.salvaSottostanteFondoModifica(this.props.index).then(
                resolve => {
                    // this.accordionOnClick();
                }
            )
        }
    }



    dataFormat(value, row, index) {
        if (value === "0") {
            return "-";
        }

        return DateFormatter.dataFormatter(value);
    }

    showConfirmPanel() {
        console.log(" show pop up");
        this.setState({ showConfirm: true })
    }

    showConfirmPanelFondo() {
        console.log(this.componentName + 'showConfirmPanel [showConfirm] ' + this.state.showConfirm);
        // this.props.showPopUP(!this.props.showConfirm);
        this.setState({ showConfirm: !this.state.showConfirm })
    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    annullaCreazioneFondo() {

        let linea = this.props.linea;
        let fondi = linea.listProdottoLineaFondi;

        // if (fondi) {
        //     this.props.removeOptionFromList(this.props.index, fondi.length - 1);
        // }
        this.showConfirmPanelFondo();
    }

    downloadOnClick(id) {
        console.log(this.componentName + " showConfirmPanel()");
        let path = "document/download/" + id;
        this.props.downloadDocument(path);
    }

    deleteLineaDocument() {
        this.showConfirmDeleteLinea();
        this.props.deleteProdottoLineaDocument(this.state.docDaEliminare).then(
            resolve => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
                this.props.getLineProdotto(this.props.linea.idProdotto);
            }
        )
    }

    inzializzaEliminaDocumentLinea(idDoc) {

        this.setState({ docDaEliminare: idDoc, showConfirmDeleteLinea: true });

    }



    render() {
        console.log(this.componentName + "render [indexLinea] " + this.props.index);
        if (isNullOrUndefined(this.props.linea)) {
            return;
        }
        let linea = this.props.linea;
        let disabled = this.props.disabled;
        let isListaToEditButton = this.props.isListaToEditButton;

        let valoreObbligatoriaErrore = (<small className="invalid-feedback d-block" >
            <i aria-hidden="true" className='fa fa-times'></i> {' '}
            {i18n('ARM_CORE_QUEST.SHARED.VALORE_OBBLIGATIRIA', 'valore obbligatoria')}
        </small>)

        let fondi = this.props.fondiList;

        let fondiCombo = [];
        if (fondi && Array.isArray(fondi)) {
            let prodottoCmp = this.props.prodotto.prodottoCmpPojo.prodottoCmp;
            if (this.props.linea.linTipoOicr) {
                fondi.forEach(
                    element => {

                        if (element.fonTipo === 'OICR') {
                            let desc = element.fonDescrizione;
                            if (desc) {
                                desc = element.fonId + "-" + element.fonDescrizione;
                                // element.fonDescrizione = desc
                            } else {
                                // element.fonDescrizione = element.fonId
                                desc = element.fonId
                            }
                            fondiCombo.push({ fonId: element.fonId, fonDescrizione: desc });
                        }
                    }
                )
            } else {
                // fondiCombo = fondi;
                fondi.forEach(

                    element => {

                        if (element.fonTipo !== 'OICR') {

                            let desc = element.fonDescrizione;
                            if (desc) {
                                desc = element.fonId + "-" + element.fonDescrizione;
                                // element.fonDescrizione = desc
                            } else {
                                // element.fonDescrizione = element.fonId
                                desc = element.fonId
                            }
                            fondiCombo.push({ fonId: element.fonId, fonDescrizione: desc });
                        }
                    }
                )
            }
        }

        let columns = [
            { field: 'idProdottoLineaFondo', title: 'Id', sortable: 'true' },
            { field: 'fonDescrizione', title: i18n('ARM_CORE_PRODUCT.MANAGE.DESCRIZIONE', 'Descrizione') },
            { field: 'percMin', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MIN', '% Min') },
            { field: 'percMax', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MAX', '% Max') },
            { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Update'), formatter: this.dataFormat },
            { field: 'fonIsin', title: i18n('ARM_CORE_PRODUCT.MANAGE.CODICE_ISIN', 'Codice Isin'), formatter: this.valueCodIsin },
            { field: 'dataInizio', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_INIZIO', 'Data Inizio'), sortable: 'true' },
            { field: 'dataFine', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_FINE', 'Data Fine'), sortable: 'true' },
            { field: 'dataInizioBanca', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_INIZIO_BANCA', 'Data Inizio Banca'), sortable: 'true' },
            { field: 'dataFineBanca', title: i18n('ARM_CORE_PRODUCT.MANAGE.DATA_FINE_BANCA', 'Data Fine Banca'), sortable: 'true' },
            //{ field: 'edit', title: 'Modifica', formatter: this.columnEdit, },
            { field: 'elimina', title: 'Elimina', formatter: this.columnDelete, },
            { field: 'docId', title: 'KID', formatter: this.uploadDoc, },
            { field: 'docIdDel', title: 'Elimina KID', formatter: this.columnDeleteDoc, }
        ];


        // $(this.refs.fondiTable).bootstrapTable({

        //     columns: columns,
        //     idField: "fonId",
        //     sortable: true,
        //     search: true,
        //     pageSize: 5,
        //     showColumns: true,
        //     showExport: true,
        //     exportDataType: 'all',
        //     exportTypes: ['csv', 'excel'],
        //     onClickRow: (row, $element, field) => this.editOnClick(row, $element, field),
        //     sortOrder: "desc",
        //     pagination: true,


        // });

        return (
            <div className="mt-1 mb-1">
                {/* <agui.aCardV4> */}
                <agui.Accordion
                    className={"prodottoLinea" + this.props.index}
                    disabled={false}
                    loading={false}
                    open={true}
                    // onClick = {}
                    marginBottom="12 px"
                >

                    <agui.AccordionHeader
                        className=""
                        open={true}
                        closeIcon="fa fa-chevron-down"
                        openIcon="fa fa-chevron-up"

                    >
                        <div className="mb-3">
                            {/* <SwitchButtonV4
                                id="inFlcorrisp"
                                key={"lineaPrincipale"}
                                title="Principale"
                                value={linea.inFlcorrisp === true || linea.inFlcorrisp === "true" || linea.inFlcorrisp === "1"}
                                label={i18n('ARM_CORE_PRODUCT.LINEA.LINEA.PRINCIPALE', 'Principale')}
                                name={"lineaPrincipale"}
                                componentClass="mt-1 float-right"
                                disabled={(this.state.disabilitaSwitch === true || this.state.disabilitaSwitch === "true") ? true : disabled}
                                classNameInput="float-right"
                                onChange={this.inputChangeHandler} /> */}
                        </div>
                        <div>
                            {this.props.titleCard}
                        </div>
                        {/* </agui.aCardV4Header> */}
                    </agui.AccordionHeader>

                    <agui.AccordionBody className="mt-2">
                        {/* <agui.aCardV4Body className="mt-2" > */}
                        <div className="row">

                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">

                                <agui.ATextInputV4
                                    id={"linNome" + this.props.index}
                                    key={"linNome"}
                                    name={"linNome"}
                                    className="coolTextInput"
                                    required
                                    label={i18n('ARM_CORE_PRODUCT.LINEA.NOME', 'Nome')}
                                    disabled={this.props.disabled}
                                    validation={this.props.validation}
                                    value={linea ? linea.linNome : null}
                                    onChange={this.inputChangeHandler}
                                />
                                {/* <agui.CoolSelect
                                    id="inNaz"
                                    key={"inNaz"}
                                    name={"inNaz"}
                                    label={i18n('ARM_CORE_PRODUCT.LINEA.LINEA.NAZIONE', 'Nazione')}
                                    disabled={disabled}
                                    validation={this.props.validation}
                                    value={linea.inNaz}
                                    valueKey='value'
                                    labelKey='label'
                                    block={true}
                                    items={this.state.listNaz}
                                    onChange={this.inputChangeHandler}
                                /> */}
                            </div>
                            {/* </div>
                        <div className="row"> */}
                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                <agui.ATextInputV4
                                    id={"linDescrizione" + this.props.index}
                                    key={"linDescrizione"}
                                    name={"linDescrizione"}
                                    required
                                    validation={this.props.validation}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}
                                    disabled={this.props.disabled}
                                    value={linea ? linea.linDescrizione : null}
                                    onChange={this.inputChangeHandler}
                                />
                            </div>


                            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4 id={"linOrdine" + this.props.index} type="number"
                                    value={linea.ordine}
                                    validation={this.props.validation}
                                    disabled={this.props.disabled}
                                    name="ordine"
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.POSIZIONE', 'Ordine Visibilità')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                        </div>

                        <div className="row ">
                            <div className="col-6 col-lg-2 col-md-2">
                                <agui.ATextInputV4 id="linValMinImporto" type="number"
                                    value={linea.linValMinImporto}
                                    name="linValMinImporto"
                                    disabled={this.props.disabled}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MIN_IMPORTO', 'Min Importo')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-6 col-lg-2 col-md-2">
                                <agui.ATextInputV4 id="linValMaxImporto" type="number"
                                    value={linea.linValMaxImporto}
                                    disabled={this.props.disabled}
                                    name="linValMaxImporto"
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MAX_IMPORTO', 'Max Importo')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            {/* </div>
                        <div className="row "> */}
                            <div className="col-6 col-lg-2 col-md-2">
                                <agui.ATextInputV4 id={"linValMinPercentuale" + this.props.index} type="number"
                                    value={linea.linValMinPercentuale}
                                    disabled={this.props.disabled}
                                    validation={this.props.validation}
                                    name="linValMinPercentuale"
                                    minValueAllowed={0}
                                    maxValueAllowed={100}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MIN_PERC', 'Min Percentuale')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-6 col-lg-2 col-md-2">
                                <agui.ATextInputV4 id={"linValMaxPecentuale" + this.props.index} type="number"
                                    value={linea.linValMaxPecentuale}
                                    disabled={this.props.disabled}
                                    validation={this.props.validation}
                                    name="linValMaxPecentuale"
                                    minValueAllowed={0}
                                    maxValueAllowed={100}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MAX_PERC', 'Max Percentuale')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            {/* </div>
                        <div className="row "> */}
                            <div className="col-6 col-lg-2 col-md-2">
                                <agui.ATextInputV4 id={"linInizioValidita" + this.props.index} type="date"
                                    value={linea.linInizioValidita ?
                                        DateFormatter.formatDateFromMilisToString(linea.linInizioValidita) : ""}
                                    disabled={this.props.disabled}
                                    required
                                    validation={this.props.validation}
                                    name="linInizioValidita"
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.INIZIO_VALIDITA', 'Inizio Validita')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-6 col-lg-2 col-md-2">
                                <agui.ATextInputV4 id="linFineValidita" type="date"
                                    value={linea.linFineValidita ? DateFormatter.formatDateFromMilisToString(linea.linFineValidita) : ""}
                                    disabled={this.props.disabled}
                                    name="linFineValidita"
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.FINE_VALIDITA', 'Fine Validita')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                        </div>
                        <div className="row">
                            {/* <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4
                                    id={"linCodCompagniaIsvap" + this.props.index}
                                    name="linCodCompagniaIsvap"
                                    validation={this.props.validation}
                                    onChange={this.inputChangeHandler}
                                    disabled={this.props.disabled}
                                    value={linea.linCodCompagniaIsvap}
                                    label={i18n('ARM_CORE_PRODUCT.FONDO.COMPAGNIA', 'Compagnia ISVAP')}
                                />

                            </div> */}
                            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4 id={"linCodIntero" + this.props.index} type="text"
                                    value={linea.linCodIntero}
                                    name="linCodIntero"
                                    disabled={this.props.disabled}
                                    validation={this.props.validation}
                                    label={i18n('ARM_CORE_PRODUCT.FONDO.COD_INTERNO', 'Codice Interno')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4 id={"linCodBanca" + this.props.index} type="text"
                                    value={linea.linCodBanca}
                                    validation={this.props.validation}
                                    disabled={this.props.disabled}
                                    name="linCodBanca"
                                    label={i18n('ARM_CORE_PRODUCT.FONDO.CODICE.BANCA', 'Codice banca')}
                                    onChange={this.inputChangeHandler} />
                            </div>


                        </div>


                        <div className="row">

                            <SwitchButton
                                id="gestioneSeparata"
                                name="gestioneSeparata"
                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GESTIONE_SEPARARATA', 'Gestione separata')}
                                value={linea.gestioneSeparata &&
                                    linea.gestioneSeparata === true || linea.gestioneSeparata === "true"}
                                disabled={this.props.disabled}
                                componentClass="col-sm-12 col-md-4 col-lg-3 mb-3"
                                onChange={this.inputChangeHandler}
                            />

                            {!linea.gestioneSeparata &&
                                <SwitchButton
                                    id="linDettaglioSottostanti"
                                    name="linDettaglioSottostanti"
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SOTTOSTANTI', 'Sottostanti')}
                                    value={linea.linDettaglioSottostanti &&
                                        linea.linDettaglioSottostanti === true || linea.linDettaglioSottostanti === "true"}
                                    disabled={this.props.disabled}
                                    componentClass="col-sm-12 col-md-4 col-lg-3 mb-3"
                                    onChange={this.inputChangeHandler}
                                />}


                            {linea.linDettaglioSottostanti && !linea.gestioneSeparata ?
                                <SwitchButton
                                    id="linTipoOicr"
                                    name="linTipoOicr"
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.TIPO_OICR', 'Tipo OICR')}
                                    value={linea.linTipoOicr &&
                                        linea.linTipoOicr === true || linea.linTipoOicr === "true"}
                                    disabled={this.props.disabled}
                                    componentClass="col-sm-12 col-md-4 col-lg-3 mb-3"
                                    onChange={this.inputChangeHandler}
                                /> : null}

                            {linea != null && linea != undefined && linea.docId != null && linea.docId != undefined ?
                                <div >

                                    <agui.aButton id="download" className="float-right btn btn-primary ml-2" icon="fas fa-download" onClick={() => this.downloadOnClick(linea.docId)}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'KID')}</agui.aButton>

                                    <agui.aButton id="trash" className="float-right btn btn-danger" icon="fas fa-trash-alt" onClick={() => this.inzializzaEliminaDocumentLinea(linea.idProdottoLinea)}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'KID')}</agui.aButton>

                                </div>
                                :
                                <div >
                                    <agui.aButton id="upload" bs="primary" className="float-right" disabled={linea.idProdottoLinea == null || linea.idProdottoLinea == undefined} icon="fas fa-upload" onClick={this.showUploadLinea}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'KID')}</agui.aButton>
                                </div>
                            }
                            <LineaDocumentUpload show={this.state.showUploadLinea} linea={linea} idLinea={linea.idProdottoLinea} idProdottoLineaFondo={""} idProdotto={linea.idProdotto} close={this.showUploadLinea} />

                            {linea.linDettaglioSottostanti && !linea.gestioneSeparata ?
                                <div className="col-6 col-lg-3 col-md-3 ml-2">
                                    <agui.ATextInputV4 id="linMinSottostanti" type="number"
                                        value={linea.linMinSottostanti}
                                        minValueAllowed={0}
                                        validation={this.props.validation}
                                        name="linMinSottostanti"
                                        disabled={this.props.disabled}
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MIN_SOTT', 'Min Sottostanti')}
                                        onChange={this.inputChangeHandler} />
                                </div> : null}
                            {linea.linDettaglioSottostanti && !linea.gestioneSeparata ?
                                <div className="col-6 col-lg-3 col-md-3">
                                    <agui.ATextInputV4 id={"linMaxSottostanti" + this.props.index} type="number"
                                        value={linea.linMaxSottostanti}
                                        minValueAllowed={0}
                                        disabled={this.props.disabled}
                                        validation={this.props.validation}
                                        name="linMaxSottostanti"
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MAC_SOTT', 'Max Sottostanti')}
                                        onChange={this.inputChangeHandler} />
                                </div> : null}
                            {/* {! && linea.linDettaglioSottostanti && !linea.gestioneSeparata
                                ? <div className="col-6 col-lg-2 col-md-2">
                                    <agui.ATextInputV4 id={"percMinFondo" + this.props.index} type="number"
                                        value={linea.percMinFondo}
                                        disabled={this.props.disabled}
                                        validation={this.props.validation}
                                        name="percMinFondo"
                                        minValueAllowed={0}
                                        maxValueAllowed={100}
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MIN_PERC_FONDO', 'Min Percentuale Fondi')}
                                        onChange={this.inputChangeHandler} />
                                </div> : null}
                            {! && linea.linDettaglioSottostanti && !linea.gestioneSeparata ?
                                <div className="col-6 col-lg-2 col-md-2">
                                    <agui.ATextInputV4 id={"percMaxFondo" + this.props.index} type="number"
                                        value={linea.percMaxFondo}
                                        disabled={this.props.disabled}
                                        validation={this.props.validation}
                                        name="percMaxFondo"
                                        minValueAllowed={0}
                                        maxValueAllowed={100}
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.LIN_VAL_MAX_PERC_FONDO', 'Max Percentuale Fondo')}
                                        onChange={this.inputChangeHandler} />
                                </div> : null} */}

                        </div>
                        {linea.linDettaglioSottostanti && !linea.gestioneSeparata ?
                            null
                            // <div className="mt-1 mb-3">

                            //     <agui.aCardV4Header>
                            //         <div className="mb-3">
                            //         </div>
                            //         <div>
                            //             {i18n('ARM_CORE_PRODUCT.PRODOTTO.SOTTOSTANTI', 'Sottostanti')}
                            //         </div>
                            //     </agui.aCardV4Header>
                            //     {linea.listProdottoLineaFondi && linea.listProdottoLineaFondi.map((item, index) =>
                            //         <div key={"row" + index} className="row">

                            //             <div key={"item" + index} className="col col-sm-3 col-md-3 col-lg-3 ml-2">
                            //                 <div key={"inputGroupOpzione" + index} className="input-group">

                            //                     <label key={"label_item" + index} className='input-group-addon mt-1'>
                            //                         <i className="fa fa-list-alt"
                            //                             style={
                            //                                 {
                            //                                     fontSize: 23
                            //                                 }
                            //                             }
                            //                             inline="true"></i></label>
                            //                     <select className="form-control "
                            //                         // id={risposta.idRisposta} 
                            //                         style={
                            //                             {
                            //                                 outlineWidth: 0,
                            //                                 outline: 0,
                            //                                 outlineColor: "white",
                            //                                 borderTop: 0,
                            //                                 borderRight: 0,
                            //                                 borderLeft: 0,
                            //                                 borderBottomWidth: "2px",
                            //                                 borderBottomColor: this.state.validationSottoStanti && !isNullOrUndefined(this.state.validationSottoStanti.get("idFondo" + index)) ? "red" : "#2196F3"
                            //                             }
                            //                         }
                            //                         id={"idFondo" + index}
                            //                         disabled={this.props.disabled}
                            //                         placeholder={"Inserisci percentuale min "}
                            //                         name="idFondo"
                            //                         value={item ? item.idFondo : ""}
                            //                         onChange={(e) => this.inputChangeHandlerFondi(this.props.index, index, "idFondo", e.target.value)} >
                            //                         <option value="DEFAULT" >{i18n('QST.SHARED.EFFETUA_UNA_SCELTA', 'Effettua una scelta')}</option>
                            //                         {
                            //                             this.props.fondiList && this.props.fondiList.map((fondo, index) =>
                            //                                 <option value={fondo.fonId} id={index} key={'R' + index}  > {fondo.fonNome}</option>
                            //                             )}
                            //                     </select>
                            //                     {this.state.validationSottoStanti && !isNullOrUndefined(this.state.validationSottoStanti.get("idFondo" + index)) ? valoreObbligatoriaErrore : null}
                            //                 </div>
                            //             </div>


                            //             <div key={"fondo" + index} className="col col-sm-3 col-md-3 col-lg-3 ml-2">
                            //                 <div key={"inputGroupFondo" + index} className="input-group">

                            //                     <label key={"labelFondo" + index} className='input-group-addon mt-1'>
                            //                         {/* <i className="fa fa-list-alt"
                            //                         style={
                            //                             {
                            //                                 fontSize: 23
                            //                             }
                            //                         }
                            //                         inline="true"></i> */}
                            //                     </label>

                            //                     <input
                            //                         key={"ColPerMin" + index}
                            //                         type="number" className="form-control"
                            //                         // id={risposta.idRisposta} 
                            //                         style={
                            //                             {
                            //                                 outlineWidth: 0,
                            //                                 outline: 0,
                            //                                 outlineColor: "white",
                            //                                 borderTop: 0,
                            //                                 borderRight: 0,
                            //                                 borderLeft: 0,
                            //                                 borderBottomWidth: "2px",
                            //                                 borderBottomColor: this.state.validationSottoStanti && !isNullOrUndefined(this.state.validationSottoStanti.get("percMin" + index)) ? "red" : "#2196F3"
                            //                             }
                            //                         }
                            //                         id={"percMin" + index}
                            //                         disabled={this.props.disabled}
                            //                         placeholder={"Inserisci percentuale min "}
                            //                         name="percMin"
                            //                         value={item ? item.percMin : ""}
                            //                         onChange={(e) => this.inputChangeHandlerFondi(this.props.index, index, "percMin", e.target.value)} />
                            //                     {this.state.validationSottoStanti && !isNullOrUndefined(this.state.validationSottoStanti.get("percMin" + index)) ? valoreObbligatoriaErrore : null}
                            //                 </div>
                            //             </div>


                            //             <div key={"colPercMax" + index} className="col col-sm-3 col-md-3 col-lg-3 ">
                            //                 <input
                            //                     key={"max" + index}
                            //                     type={"number"}
                            //                     className="form-control"
                            //                     // id={risposta.idRisposta} 
                            //                     style={
                            //                         {
                            //                             outlineWidth: 0,
                            //                             outline: 0,
                            //                             outlineColor: "white",
                            //                             borderTop: 0,
                            //                             borderRight: 0,
                            //                             borderLeft: 0,
                            //                             borderBottomWidth: "2px",
                            //                             borderBottomColor: this.state.validationSottoStanti && !isNullOrUndefined(this.state.validationSottoStanti.get("percMax" + index)) ? "red" : "#2196F3"
                            //                         }
                            //                     }
                            //                     disabled={this.props.disabled}
                            //                     id={"percMax" + index}
                            //                     placeholder={"Inserisci percentuale max "}
                            //                     name="percMax"
                            //                     value={item ? item.percMax : ""}
                            //                     onChange={(e) => this.inputChangeHandlerFondi(this.props.index, index, "percMax", e.target.value)} />
                            //                 {this.state.validationSottoStanti && !isNullOrUndefined(this.state.validationSottoStanti.get("percMax" + index)) ? valoreObbligatoriaErrore : null}
                            //             </div>
                            //             {linea.listProdottoLineaFondi.length === 1 ? null :
                            //                 // <div className="col col-sm-1 col-md-1 col-lg-1 ">
                            //                 <button type="button"
                            //                     className="mb-3"
                            //                     id={"remove" + index}
                            //                     disabled={this.props.disabled}
                            //                     style={
                            //                         {
                            //                             color: "gray",
                            //                             fontSize: "25px",
                            //                             outlineWidth: 0,
                            //                             outline: 0,
                            //                             outlineColor: "white",
                            //                             padding: 0,
                            //                             border: 0,
                            //                             background: 0
                            //                         }

                            //                     } onClick={() => this.props.removeOptionFromList(this.props.index, index)}  >
                            //                     <i className="fas fa-times"></i></button>
                            //                 // </div>
                            //             }
                            //         </div>
                            //     )
                            //     }

                            //     <button type="button" className="btn btn-link" disabled={this.props.disabled} onClick={() => this.props.addOptionButton(this.props.index)}>{i18n('ARM_CORE_QUEST.SHARED.AGGIUNGI_FONDO', 'Aggiungi Sottosante')}</button>
                            //     {/* <button type="button" className="btn btn-link" onClick={this.caricaDominioButton}>Carica un dominio</button> */}
                            // </div>
                            : null}

                        {linea && linea.docName ?

                            <div className='row'>
                                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                    <agui.ATextInputV4 id={"Nome Documento" + this.props.index} type="text"
                                        value={linea.docName}
                                        validation={this.props.validation}
                                        disabled={this.props.disabled}
                                        name="Nome Documento"
                                        onChange={this.inputChangeHandler} />
                                </div>
                            </div>
                            : null
                        }

                        <div>
                            {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                                <agui.aButton className="float-left mt-2" bs='primary' disabled={this.props.disabled || (linea.gestioneSeparata || !linea.linDettaglioSottostanti)} onClick={() => this.inizializzaNuovoFondo()} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.FONDI.SOTTOSTANTE', 'Sottostante')}</agui.aButton>
                            }
                            {/* } */}
                            {/* {!linea.gestioneSeparata && */}

                        </div>




                        {/* } */}
                        {/* </agui.aCardV4Body> */}
                        <div>
                            <table id={"tableAcc" + this.props.index} ref="fondiTable" columns={columns} data={this.props.linea.listProdottoLineaFondi} className={AppConstants.CLASS_TABLE} />
                            <LineaDocumentUpload show={this.state.showUpload} linea={""} idProdottoLineaFondo={this.state.idProdottoLineaFondo} idProdotto={this.props.linea.idProdotto} close={this.cancelUploadDoc} />
                        </div>
                    </agui.AccordionBody>

                    {
                        (!isListaToEditButton) ?
                            <div className=" ml-4 mr-4 mb-3">
                                {
                                    (!disabled) ?
                                        <div className='d-flex justify-content-between' >
                                            <agui.aButton bs="secondary" title={i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA_ANULLA', "Annulla modifica")} id={this.props.index} className="float-right" icon="far fa-times-circle" onClick={this.props.onClickAnnullaModifica}></agui.aButton>
                                            <agui.aButton bs="primary" title="Salva Modifiche" id={this.props.index} className="mr-2" icon="fas fa-save" onClick={this.onClickSalvaLinea}></agui.aButton>
                                        </div>
                                        :

                                        linea.inFlcorrisp ?

                                            <div className='d-flex justify-content-between float-right' >

                                                <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.LINEA.MODIFICA_LINEA', "Modifica linea")} id={this.props.index} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickModificaLinea}></agui.aButton>
                                            </div>
                                            :
                                            <div className='d-flex justify-content-between' >

                                                <agui.aButton id={linea.idProdottoLinea} bs="danger" title={i18n('ARM_CORE_PRODUCT.LINEA.ELIMINA_LINEA', "Elimina linea")} className="float-right" icon="fas fa-trash-alt" onClick={this.props.onClickEliminaLinea}></agui.aButton>
                                                <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.LINEA.MODIFICA_LINEA', "Modifica linea")} id={this.props.index} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickModificaLinea}></agui.aButton>
                                            </div>

                                }
                            </div>
                            :


                            <div className="d-flex flex-row-reverse">
                                <div className="p-2">
                                    {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                                        <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', "Modifica")} id={"edit"} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickGestioneLinea}>{i18n('ARM_CORE_PRODUCT.SHARED.GESTIONE.Linea', "Gestione")}</agui.aButton>
                                    }
                                </div>
                            </div>
                    }
                    {/* </agui.aCardV4> */}

                </agui.Accordion>
                <agui.ConfirmModalOkCancelV4 show={this.state.showConfirm} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle="Associazione Fondo" onClose={this.annullaCreazioneFondo} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="idFondo"
                                    disabled={false}
                                    onChange={(e) => this.inputChangeHandlerFondi("idFondo", e.target.value)}
                                    value={this.props.fondo ? this.props.fondo.idFondo : null}
                                    label={i18n('ARM_CORE_PRODUCT.FONDI.ID_FONDO', 'Fondo')}
                                    items={fondiCombo}
                                    validation={this.state.validationSottoStanti}
                                    valueKey="fonId"
                                    labelKey="fonDescrizione"
                                />
                            </div>
                        </div>


                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percMin" type="number"
                                    value={this.props.fondo ? this.props.fondo.percMin : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% min')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationSottoStanti}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% min')}
                                    onChange={(e) => this.inputChangeHandlerFondi("percMin", e.target.value)} />
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percMax" type="number"
                                    value={this.props.fondo ? this.props.fondo.percMax : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MAX', '% max')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationSottoStanti}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MAX', '% max')}
                                    onChange={(e) => this.inputChangeHandlerFondi("percMax", e.target.value)} />
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataInizio" type="date"
                                    value={this.props.fondo.dataInizio ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataInizio) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                    required={true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataInizio", e.target.value)}
                                    disabled = {true}
                                    />
                            </div>


                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataFine" type="date"
                                    value={this.props.fondo.dataFine ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataFine) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                    required={true}
                                    disabled = {true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataFine", e.target.value)} />
                            </div>
                        </div>

                        <div className="row mt-1">

                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataInizioBanca" type="date"
                                    value={this.props.fondo.dataInizioBanca ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataInizioBanca) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_BANCA', 'Inizio Validità Banca ')}
                                    required={true}
                                    disabled = {true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_DATA_BANCA', 'Inizio Validità Banca ')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataInizioBanca", e.target.value)} />
                            </div>


                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataFineBanca" type="date"
                                    value={this.props.fondo.dataFineBanca ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataFineBanca) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                    required={true}
                                    disabled = {true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataFineBanca", e.target.value)} />
                            </div>
                        </div>

                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaSottostante} onClose={this.annullaCreazioneFondo}>
                    </agui.ConfirmModalOkCancelV4.Footer>

                </agui.ConfirmModalOkCancelV4>

                < agui.ConfirmModalOkCancelV4 show={this.state.modificaFondo} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle="Associazione Fondo" onClose={this.showConfirmPanelFondoModifica} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="idFondo"
                                    disabled={false}
                                    onChange={(e) => this.inputChangeHandlerFondi("idFondo", e.target.value)}
                                    value={this.props.fondo ? this.props.fondo.idFondo : null}
                                    label={i18n('ARM_CORE_PRODUCT.FONDI.ID_FONDO', 'Fondo')}
                                    items={fondiCombo}
                                    validation={this.state.validationSottoStanti}
                                    valueKey="fonId"
                                    labelKey="fonDescrizione"
                                />
                            </div>
                        </div>


                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percMin" type="number"
                                    value={this.props.fondo ? this.props.fondo.percMin : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% min')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationSottoStanti}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% min')}
                                    onChange={(e) => this.inputChangeHandlerFondi("percMin", e.target.value)} />
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percMax" type="number"
                                    value={this.props.fondo ? this.props.fondo.percMax : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MAX', '% max')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationSottoStanti}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MAX', '% max')}
                                    onChange={(e) => this.inputChangeHandlerFondi("percMax", e.target.value)} />
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataInizio" type="date"
                                    value={this.props.fondo.dataInizio ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataInizio) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                    required={true}
                                    disabled={true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataInizio", e.target.value)} />
                            </div>


                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataFine" type="date"
                                    value={this.props.fondo.dataFine ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataFine) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                    required={true}
                                    disabled={true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataFine", e.target.value)} />
                            </div>
                        </div>

                        <div className="row mt-1">

                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataInizioBanca" type="date"
                                    value={this.props.fondo.dataInizioBanca ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataInizioBanca) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_BANCA', 'Inizio Validità Banca ')}
                                    required={true}
                                    disabled={true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_DATA_BANCA', 'Inizio Validità Banca ')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataInizioBanca", e.target.value)} />
                            </div>


                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataFineBanca" type="date"
                                    value={this.props.fondo.dataFineBanca ? DateFormatter.formatDateFromMilisToString(this.props.fondo.dataFineBanca) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                    required={true}
                                    disabled={true}
                                    validation={this.state.validationSottoStanti}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                    onChange={(e) => this.inputChangeHandlerFondi("dataFineBanca", e.target.value)} />
                            </div>
                        </div>


                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaSottostanteFondoModifica} onClose={this.showConfirmPanelFondoModifica}>
                    </agui.ConfirmModalOkCancelV4.Footer>

                </agui.ConfirmModalOkCancelV4>


                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteProdottoLineaFondoDocument}
                    onClose={this.showConfirmDelete} />

                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDeleteLinea}
                    deleteOnClick={this.deleteLineaDocument}
                    onClose={this.showConfirmDeleteLinea} />


            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {

        setPathNameToReturn(path) {
            return dispatch(AppActions.setPathNemeToReturn(path));
        },

        handleChangeLinea(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeLinea(index, parametro, value));
        },

        handleChangeLineaAnagrafica(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeLineaAnagrafica(index, parametro, value));
        },

        handleChangeEditLinea(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeEditLinea(index, parametro, value));
        },

        manageLineaSottostanti(value, index) {
            return dispatch(ProdottoActions.manageLineaSottostanti(value, index));
        },

        removeOptionFromList(indexLinea, indexFondo) {
            return dispatch(ProdottoActions.removeOptionFromList(indexLinea, indexFondo))
        },

        addOptionButton(indexLinea) {
            return dispatch(ProdottoActions.addOptionButton(indexLinea))
        },

        inputChangeHandlerFondi(indexLinea, indexFondo, name, value) {
            return dispatch(ProdottoActions.inputChangeHandlerFondi(indexLinea, indexFondo, name, value))
        },

        inputChangeHandlerFondo(name, value) {
            return dispatch(ProdottoActions.inputChangeHandlerFondo(name, value))
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        salvaSottostante(index) {
            return dispatch(ProdottoActions.salvaSottostante(index))
        },

        inizializzaNuovoFondo() {
            return dispatch(ProdottoActions.inizializzaNuovoFondo())
        },

        inizializzaModificaFondo(row) {
            return dispatch(ProdottoActions.inizializzaModificaFondo(row))
        },

        getLineProdotto(id) {
            return dispatch(ProdottoActions.getLineProdotto(id))
        },

        deleteProdottoLineaDocument(id) {
            return dispatch(ProdottoActions.deleteProdottoLineaDocument(id))
        },
        deleteProdottoLineaFondoDocument(id) {
            return dispatch(ProdottoActions.deleteProdottoLineaFondoDocument(id))
        },
        salvaSottostanteFondoModifica(index) {
            return dispatch(ProdottoActions.salvaSottostanteFondoModifica(index))
        },
        getFondoDetails(fonId) {
            return dispatch(FondiAction.getFondoDetails(fonId));
        },

    }
};

function mapStateToProps(state) {
    return {
        pathToReturn: state.app.pathNameToReturn,
        showConfirm: state.app.showPopUp,
        fondo: state.prodotto.fondo,
        prodotto: state.prodotto.detailsProdotto,
        fondiList: state.prodotto.listFondiProdotto,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(LineaCard);
